import { connect } from 'react-redux';
import Form from './Form';

import { addTextToDraft, addImageToDraft, removeImageFromDraft } from '../../actions/draftAction';

const mapStateToProps = (state) => ({
  draft: state.draft,
});
const mapDispachToProps = (dispatch) => ({
  onTextChange: (text) => dispatch(addTextToDraft(text)),
  onImageChange: (image) => dispatch(addImageToDraft(image)),
  onImageRemove: (image) => dispatch(removeImageFromDraft(image)),
});

export default connect(mapStateToProps, mapDispachToProps)(Form);
